import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: 'button[appBusy]',
  standalone: false,
})
export class BusyButtonDirective implements OnChanges {
  @Input() appBusy: boolean | null = false;

  private spinner?: HTMLElement;
  private disabledByBusy = false;

  constructor(
    private el: ElementRef<HTMLButtonElement>,
    private renderer: Renderer2,
  ) {}

  ngOnChanges(): void {
    const btn = this.el.nativeElement;
    if (this.appBusy) {
      this.renderer.setAttribute(btn, 'disabled', 'true');
      this.disabledByBusy = true;
      if (!this.spinner) {
        const spinner = this.renderer.createElement('span');
        this.renderer.addClass(spinner, 'spinner-border');
        this.renderer.addClass(spinner, 'spinner-border-sm');
        this.renderer.addClass(spinner, 'me-2');
        this.renderer.setAttribute(spinner, 'role', 'status');
        this.renderer.setAttribute(spinner, 'aria-hidden', 'true');
        this.renderer.insertBefore(btn, spinner, btn.firstChild);
        this.spinner = spinner;
      }
    } else {
      // Only clear disabled if this directive set it for the busy state;
      // never clobber an external [disabled] binding (e.g. an "I agree" guard).
      if (this.disabledByBusy) {
        this.renderer.removeAttribute(btn, 'disabled');
        this.disabledByBusy = false;
      }
      if (this.spinner) {
        this.renderer.removeChild(btn, this.spinner);
        this.spinner = undefined;
      }
    }
  }
}
